import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RequestIntermediarioEnlace } from '../Modelos/RequestIntermediarioEnlace';
import { IntermediarioEnlaceAcceso } from '../Modelos/IntermediarioEnlaceAcceso';
import { IntermediarioEnlaceGeneral } from '../Modelos/IntermediarioEnlaceGeneral';

@Injectable({
  providedIn: 'root'
})
export class EnlacePrincipalService {

  constructor() { }

  async ConsultaIntermediarioExisteAcceso(cod_agente: number): Promise<IntermediarioEnlaceAcceso[]> {
    let url = new URL(`${environment.backendUrl}/api/Intermediario/IntermediarioEnlaceAcceso`);
    url.searchParams.append('cod_agente', cod_agente.toString());

    const response = await fetch(url.toString(), { method: 'GET' });

    if (response.ok) {
      const intermediarioEnlaceAcceso: IntermediarioEnlaceAcceso[] = await response.json();
      return intermediarioEnlaceAcceso;
    } else {
      throw new Error('Error al consultar el intermediario con acceso.');
    }
  }

  async CrearAccesoIntermediarioEnlace(objRequestIntermediario: RequestIntermediarioEnlace): Promise<boolean> {
    try {
      const url = `${environment.backendUrl}/api/Intermediario/IntermediarioEnlaceAcceso`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(objRequestIntermediario)
      });

      if (response.ok) {
        const data = await response.json();
        console.log("responseActualizacionEnlace_Service",data);
        if (data !== null) {
          if(data === true){
            return true;
          }
          else{
            return false;
          }
        } else {
          throw new Error('Error al crear el acceso de intermediario enlace. La respuesta no es válida.');
        }
      } else {
        throw new Error('Error al crear el acceso de intermediario enlace. Respuesta no válida del servidor.');
      }
    } catch (error) {
      console.error('Ocurrió un error:', error);
      throw error;
    }
  }


  async ActualizarIntermediarioEnlace(objRequestIntermediario: RequestIntermediarioEnlace): Promise<IntermediarioEnlaceGeneral> {
    let url = `${environment.backendUrl}/api/Intermediario/IntermediarioEnlaceAccesoUpdate`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(objRequestIntermediario)
    });

    if (response.ok) {
      const resultado = await response.json();
      return new IntermediarioEnlaceGeneral(
        resultado.cod_Aplicacion,
        resultado.cod_tipo_agente,
        resultado.cod_agente,
        resultado.estado,
        new Date(resultado.fechaRegistro),
        resultado.cod_UsuarioSISE
      );
    } else {
      throw new Error('Error al actualizar el intermediario enlace.');
    }
  }

  async ConsultaIntermediarioEnlaceGeneral(cod_agente_: number): Promise<IntermediarioEnlaceGeneral> {

      let url = new URL(`${environment.backendUrl}/api/Intermediario/IntermediarioEnlaceGeneral`);
      url.searchParams.append('cod_agente', cod_agente_.toString());
      console.log("requestConsultaIntermediarioGeneral", cod_agente_);

      const response = await fetch(url.toString(), { method: 'GET' });

      if (response.ok) {
        const resultado = await response.json();
        const intermediario = new IntermediarioEnlaceGeneral(
          resultado.cod_Aplicacion,
          resultado.cod_tipo_agente,
          resultado.cod_agente,
          resultado.estado,
          new Date(resultado.fechaRegistro),
          resultado.cod_UsuarioSISE
        );
        console.log("responseConsultaIntermediarioGeneral", intermediario);
        return intermediario;
      } else {
        throw new Error('Error al consultar el intermediario enlace general.');
      }
  }

}
